import {hideSpinner, showSpinner} from './utility.js';
import {initializeComponents} from './initializer.js';
import {addActionSheet} from './action_sheet.js';
import {closeActiveMenus} from './menu.js';

const page_modals = new Map();
const modal_vars = {};

export function getModalVar(modal_id, key, default_value) {
    if (modal_vars.hasOwnProperty(modal_id)) {
        if (modal_vars[modal_id].hasOwnProperty(key)) {
            return modal_vars[modal_id][key];
        } else {
            console.error(`Modal variable: "${modal_id}" not found`);
        }
    } else {
        console.error(`Modal ID: "${modal_id}" not found`);
    }
    return default_value || undefined;
}

export function ajaxModal(options) {
    showSpinner();

    let ajax_options = {};

    if (!options.url || options.url.length === 0) {
        console.error('Ajax modal error - invalid url');
        return;
    }

    ajax_options.url = options.url;
    ajax_options.type = 'GET';
    ajax_options.dataType = 'JSON';
    /*ajax_options.crossDomain = true;
    ajax_options.headers = {
        'X-Requested-With': 'XMLHttpRequest'
    };

    if (options.data) {
        ajax_options.method = 'POST';
        ajax_options.dataType = 'json';

        ajax_options.data = options.data;

    } else {
        /*ajax_options.data = {
            'nonce': getPageVar('nonce', ''),
            'hash': getPageVar('hash', ''),
        }
    }*/

    $.ajax(ajax_options)
        .done(function (response) {
            // close all active menu
            closeActiveMenus();

            if (!response.success) {
                console.error(response.errors);
            } else {
                // hide spinner
                hideSpinner();

                // get modal_id from response
                const modal_id = response.vars.modal_id;

                // append modal html to #page
                $("body #page").append(response.html);

                // get modal element
                const el_modal = $(`[data-modal-id="${modal_id}"]`);

                if (el_modal.length === 0) {
                    console.error(`Modal ${modal_id} not added to DOM`);
                    return;
                }

                // create modal from modal element
                let bs_modal = new bootstrap.Modal(el_modal, {
                    backdrop: 'static',
                    keyboard: false,
                    focus: true
                });

                // add response.vars to `modal_vars` list
                modal_vars[modal_id] = response.vars;

                // add `el_modal` instance to `page_modals`
                page_modals.set(modal_id, el_modal);

                /**
                 * !!! must declare `shown.bs.modal` and `hidden.bs.modal` BEFORE calling bs_modal.shown();
                 */
                // wait until the modal has been shown before initializing the inner components
                el_modal.on('shown.bs.modal', function () {
                    initializeComponents(true);
                });

                // Clean up after ourselves.
                el_modal.on('hidden.bs.modal', function () {
                    // Now remove the reference we stored in the app.var.modals object
                    page_modals.delete(modal_id);
                    delete modal_vars[modal_id];

                    // remove element from dom
                    el_modal.remove();
                });

                // if iframe exist inside modal
                $('.btn[data-bs-dismiss=modal]', el_modal).on('click', function () {
                    bs_modal.hide();
                });

                // have a second delay (otherwise, calls to `shown.bs.modal` from within view/*.js won't take effect)
                setTimeout(function () {
                    bs_modal.show();
                }, 100)


                // readjust the modal's position in case a scrollbar appears
                bs_modal.handleUpdate();
            }

        })
        .fail(function (xhr) {
            // make sure we hide spinner
            hideSpinner();

            if (xhr.hasOwnProperty('responseJSON') && xhr.responseJSON.hasOwnProperty('notification')) {
                addActionSheet(xhr.responseJSON.notification, false);

            } else {
                addActionSheet(
                    {
                        type: 'error',
                        message: "Failed to load modal",
                        heading: "Unexpected error"
                    }, false
                );
            }
        });
};

export function getModal(modal_id) {
    return page_modals.get(modal_id);
}